export const styles = theme => ({
  anchorButton: {
    backgroundColor: 'transparent',
    border: 'none',
    cursor: 'pointer',
    textDecoration: 'underline',
    display: 'inline',
    margin: 0,
    padding: 0,
  },
});

export default styles;

// .button-link:hover,
// .button-link:focus {
//   text-decoration: none;
// }
